import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
export function trendsAnimations() {
    const trends = document.querySelectorAll('.trend');

    trends.forEach((trend, index) => {
        const fromX = index % 2 === 0 ? -100 : 100;

        gsap.from(trend, {
            scrollTrigger: {
                trigger: trend,
                start: "top 80%",
                toggleActions: "play none none none"
            },
            x: fromX,
            opacity: 0,
            duration: 2,
            ease: "power3.out",
        });
    });

    gsap.from('.trends__title', {
        scrollTrigger: {
            trigger: '.trends__title',
            start: "top 80%",
            toggleActions: "play none none none"
        },
        y: 50,
        opacity: 0,
        duration: 2,
        ease: "power3.out"
    });
}